module.exports = __webpack_public_path__ + "assets/img/button.241a3001.png";